import {defineStore} from 'pinia';

export const useProgressStore = defineStore('progress', {
  state: () => ({
    modal: false,
    progress: null,
  }),
  actions: {
    close() {
      this.modal = false;
      this.progress = null;
    },
    show(progress = null) {
      this.modal = true;
      this.progress = progress;
    },
  },
});
